import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import advancedfilepicker from "@/components/child/form/advancedfilepicker.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component } from "@/decorators";
import UsuarioModel from "@/models/usuarioModel";
import UsuarioService from "@/services/usuarioService";
import { AppState, SessionActions } from "@/store/store";

import "../crud.scss";

@Component({
    components: {
        actionBarComponent,
        fieldsetComponent,
        advancedfilepicker,
    },
    computed: mapState<AppState>({
        usuarioLogado: state => state.session.usuarioLogado,
    }),
})
export default class MeuperfilComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    private service = new UsuarioService();

    senhaCertificado = "";
    certificadoFile: File = null;

    private onCertificadoSelected(file: File) {
        this.certificadoFile = file;
    }

    private async save() {
        if (!this.senhaCertificado) {
            this.$showError(
                this.$t("__.ts.erro"),
                this.$t("__.Crud.meuperfil.meuperfil_vue_html.preencherCertificado"),
            );
            return;
        }

        const sucesso = await this.service
            .updateCertificate(this.certificadoFile, this.senhaCertificado)
            .withLoading()
            .resolveWithoutJSON();

        if (sucesso) {
            await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
            this.$showSuccess("Sucesso", this.$t("__.Crud.meuperfil.meuperfil_vue_html.certificadoSalvo"));
            this.$router.back();
        }
    }

    private cancel() {
        this.$router.back();
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        try {
            const response = await this.service
                .getPerfilUsuario()
                .withLoading()
                .resolveWithJSON<{ senhaCertificado: string; certificado: string }>();
            if (response && response.senhaCertificado) {
                this.senhaCertificado = response.senhaCertificado;
            }
        } catch {}
    }
}
